import React, {Component} from "react"

const Enquiry = class extends Component {
  constructor(props) {
    super(props)

    this.bindEnquiryForm = this.bindEnquiryForm.bind(this)
    this.toJSONString = this.toJSONString.bind(this)
  }

  componentDidMount() {
    const script = document.createElement("script")

    script.async = true
    script.defer = true
    script.src = "https://cdn.emailjs.com/sdk/2.2.4/email.min.js"
    script.addEventListener('load', () => {
      emailjs.init("user_AIIIQH0XbtIz1mVKO8DSb")
      this.bindEnquiryForm()
    })

    document.querySelector('.enquiry').appendChild(script)
  }

  toJSONString(form) {
		var obj = {}
		var elements = form.querySelectorAll( "input, select, textarea" )
    
    for( var i = 0; i < elements.length; ++i ) {
			var element = elements[i]
			var name = element.name
			var value = element.value

			if( name ) {
				obj[ name ] = value
			}
    }

    //return JSON.stringify(obj);
    return obj;
  }

  bindEnquiryForm() {
    const myform = document.querySelector("form.enquiry")
    
    myform.addEventListener('submit', (event) => {      
      event.preventDefault()

      const params = this.toJSONString(myform)
      // var params = myform.serializeArray().reduce(function(obj, item) {
      //     obj[item.name] = item.value
      //     return obj
      // }, {})

      // Change to your service ID, or keep using the default service
      var service_id = "smtp_server"
      var template_id = "template_AdZ3cqmm"
      var button = myform.querySelector('button')

      button.innerText = 'Sending...'
      emailjs.send(service_id,template_id,params)
        .then(function(){ 
            alert("Sent!")
            myform.reset()
            button.innerText = 'Submit'
          }, function(err) {
            alert("Send email failed!\r\n Response:\n " + JSON.stringify(err))            
            button.innerText = 'Submit'
        })

      return false
    })
  }

  render() {
    return (
      <form className="enquiry" method="post">
        <div className="fieldset cols">
          <div>
            <input type="text" maxLength="100" placeholder="Name" name="from_name" required />
          </div>
          <div>
            <input type="email" maxLength="100" placeholder="Email" name="from_email" required />
          </div>
        </div>
        <div className="fieldset cols">
          <div>
            <input type="text" maxLength="100" placeholder="Telephone" name="from_telephone" />
          </div>
          <div>
            <input type="text" maxLength="100" placeholder="Website" name="from_website" />
          </div>
        </div>
        <div className="fieldset">
          <textarea placeholder="Your message or project info" name="from_message" />
        </div>
        <div className="cols">
          <div>
          </div>
          <div>
            <button>Submit</button>
          </div>
        </div>
      </form>
    )
  }
}

export default Enquiry


// WEBPACK FOOTER //
// ./src/components/enquiry.js